module.exports = "<!-- <div class=\"sidebar-footer\"></div> -->\n"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/components/app-sidebar-footer/app-sidebar-footer.component.html
// module id = ../../../../../src/app/components/app-sidebar-footer/app-sidebar-footer.component.html
// module chunks = main